import React from 'react';
import { SiteSection, SiteSectionHeader } from '../../components/site';
import type { SolutionBentoVerticals } from './types';

export const SolutionCommercialBentoVerticals: React.FC<{
  verticals: SolutionBentoVerticals;
}> = ({ verticals }) => (
  <SiteSection id="verticals" className="cl-bento">
    <SiteSectionHeader
      eyebrow={verticals.eyebrow}
      title={verticals.title}
      subtitle={verticals.subtitle}
      align="center"
    />

    <div className="cl-bento__grid">
      {verticals.blocks.map((block) => (
        <article
          key={block.id}
          className={`cl-bento__block cl-bento__block--${block.id} cl-bento__block--${block.size} cl-bento__block--${block.theme}`}
          tabIndex={0}
        >
          <div className="cl-bento__face">
            <span className="cl-bento__beam" aria-hidden />
            <div className="cl-bento__face-head">
              <span className="cl-bento__emoji-wrap" aria-hidden>
                {block.emoji}
              </span>
              <span className="cl-bento__peek" aria-hidden>
                Hover for details
              </span>
            </div>
            <div className="cl-bento__face-body">
              <h3 className="cl-bento__title">{block.title}</h3>
              <p className="cl-bento__tagline">{block.tagline}</p>
            </div>
          </div>

          <div className="cl-bento__overlay">
            <div className="cl-bento__overlay-inner">
              <h3 className="cl-bento__overlay-title">{block.title}</h3>
              <p className="cl-bento__overlay-desc">{block.description}</p>
              {block.details?.length ? (
                <ul className="cl-bento__overlay-list">
                  {block.details.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              ) : null}
            </div>
          </div>
        </article>
      ))}
    </div>
  </SiteSection>
);
